var _rect, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHappy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 54,
    height: 54,
    rx: 27,
    stroke: "#FB7C2F",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_516_121",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 32,
    height: 32
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.5,
    y: 12.5,
    width: 31,
    height: 31,
    fill: "#D9D9D9",
    stroke: "#FB7C2F"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_516_121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.876 25.2577L23.8674 25.249L23.8586 25.2575L22.4007 26.649L21.0182 25.2665L23.8671 22.4176L26.6496 25.2664L25.2672 26.6488L23.876 25.2577ZM32.1425 25.2575L32.1336 25.249L32.125 25.2577L30.7339 26.6488L29.3514 25.2664L32.134 22.4176L34.9828 25.2665L33.6003 26.649L32.1425 25.2575ZM32.1101 34.0396C30.8788 34.8937 29.5091 35.3207 28.0005 35.3207C26.4919 35.3207 25.1222 34.8937 23.891 34.0396C22.6647 33.1889 21.7741 32.0688 21.219 30.679H34.7821C34.227 32.0688 33.3363 33.1889 32.1101 34.0396ZM28.0005 41.3207C26.1577 41.3207 24.4261 40.971 22.8055 40.2717C21.1846 39.5723 19.7749 38.6232 18.576 37.4243C17.3772 36.2255 16.4281 34.8157 15.7287 33.1949C15.0294 31.5743 14.6797 29.8427 14.6797 27.9998C14.6797 26.157 15.0294 24.4254 15.7287 22.8048C16.4281 21.184 17.3772 19.7742 18.576 18.5753C19.7749 17.3765 21.1846 16.4274 22.8055 15.728C24.4261 15.0287 26.1577 14.679 28.0005 14.679C29.8433 14.679 31.575 15.0287 33.1956 15.728C34.8164 16.4274 36.2262 17.3765 37.425 18.5753C38.6239 19.7742 39.573 21.184 40.2724 22.8048C40.9717 24.4254 41.3214 26.157 41.3214 27.9998C41.3214 29.8427 40.9717 31.5743 40.2724 33.1949C39.573 34.8157 38.6239 36.2255 37.425 37.4243C36.2262 38.6232 34.8164 39.5723 33.1956 40.2717C31.575 40.971 29.8433 41.3207 28.0005 41.3207ZM28.0005 38.679C30.9815 38.679 33.507 37.6444 35.576 35.5753C37.6451 33.5063 38.6797 30.9809 38.6797 27.9998C38.6797 25.0188 37.6451 22.4934 35.576 20.4243C33.507 18.3553 30.9815 17.3207 28.0005 17.3207C25.0195 17.3207 22.4941 18.3553 20.425 20.4243C18.356 22.4934 17.3214 25.0188 17.3214 27.9998C17.3214 30.9809 18.356 33.5063 20.425 35.5753C22.4941 37.6444 25.0195 38.679 28.0005 38.679Z",
    fill: "#FB7C2F",
    stroke: "#FB7C2F",
    strokeWidth: 0.025
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHappy);
export default __webpack_public_path__ + "static/media/happy.5fbcdd8ca65e34be0bdcb10027641162.svg";
export { ForwardRef as ReactComponent };